export enum SocketEvents {
  CONNECTION = 'connection',
  CONNECT = 'connect',
  DISCONNECT = 'disconnect',
  MESSAGE = 'message',
  DATA = 'data',
  FORM_REDIRECT = 'form_redirect'
}
